'use strict'
const React = require('react')
const StaticComponent = require('../static')

class GitlabSVGIcon extends StaticComponent {
  render() {
    const {size = 30} = this.props
    const sizeStyle = {
      width: `${size}px`,
      height: `${size}px`,
      minWidth: `${size}px`,
      minHeight: `${size}px`,
    }
    return (
      <svg width={size} height={size} style={sizeStyle} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <title>file_type_gitlab</title>
        <polygon points="16 28.896 16 28.896 21.156 13.029 10.844 13.029 16 28.896" style={{fill: '#e24329'}} />
        <polygon points="16 28.896 10.844 13.029 3.619 13.029 16 28.896" style={{fill: '#fc6d26'}} />
        <path
          d="M3.619,13.029h0L2.052,17.851a1.067,1.067,0,0,0,.388,1.193L16,28.9,3.619,13.029Z"
          style={{fill: '#fca326'}}
        />
        <path d="M3.619,13.029h7.225L7.739,3.473a.534.534,0,0,0-1.015,0L3.619,13.029Z" style={{fill: '#e24329'}} />
        <polygon points="16 28.896 21.156 13.029 28.381 13.029 16 28.896" style={{fill: '#fc6d26'}} />
        <path
          d="M28.381,13.029h0l1.567,4.822a1.067,1.067,0,0,1-.388,1.193L16,28.9,28.381,13.029Z"
          style={{fill: '#fca326'}}
        />
        <path d="M28.381,13.029H21.156l3.105-9.557a.534.534,0,0,1,1.015,0l3.105,9.557Z" style={{fill: '#e24329'}} />
      </svg>
    )
  }
}

module.exports = GitlabSVGIcon
